import { render, staticRenderFns } from "./AdmissionCommitteeEmployeeSave.vue?vue&type=template&id=363e1abd&scoped=true&"
import script from "./AdmissionCommitteeEmployeeSave.vue?vue&type=script&lang=js&"
export * from "./AdmissionCommitteeEmployeeSave.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionCommitteeEmployeeSave.vue?vue&type=style&index=0&id=363e1abd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363e1abd",
  null
  
)

export default component.exports